import styled from 'styled-components'
import theme from 'styles/theme'
import { textAlign } from 'styled-system'

export const OffersGridContainer = styled.section`
  align-items: center;
  display: flex;
  flex-direction: column;

  ${theme.mediaQueries.medium} {
    display: inherit;
  }

  > div {
    align-items: center;

    > div {
      max-width: 980px;
      width: 100%;
    }
  }

  a {
    margin-bottom: ${theme.space[6]};

    ${theme.mediaQueries.medium} {
      margin-bottom: ${theme.space[10]};
    }
  }
`

export const OffersGridHeader = styled.header`
  margin: ${theme.space[6]} 0;
  text-align: center;

  ${theme.mediaQueries.medium} {
    margin: ${theme.space[7]} 0;
  }
`

export const Section = styled.section`
  ${textAlign}
`
